const getColumnNames = header => header.map(item => Object.values(item)[0])

const getDeepAttribute = (obj, attr) =>
  attr.split('.').reduce((prev, curr) => prev[curr], obj)

const getRowScope = header => header.map(item => Object.keys(item)[0])

export default { getColumnNames, getDeepAttribute, getRowScope }
